<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="file-invoice-dollar"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-input :model="filterFormModel" attribute="keyword" class="mr-1 mb-1"
                        :placeholder="$t('keyword')"></form-input>
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-1" :options="[
                            {value: null, text: this.$t('allTypes')},
                            {value: 'new', text: this.$t('newInvoicePlanOrderType')},
                            {value: 'extend', text: this.$t('extendInvoicePlanOrderType')},
                            {value: 'esign', text: this.$t('esignInvoicePlanOrderType')},
                            ]"></form-select>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                            {value: null, text: this.$t('status')},
                            {value: '1', text: this.$t('waiting')},
                            {value: '2', text: this.$t('confirmed')},
                            {value: '3', text: this.$t('canceled')},
                            ]"></form-select>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('createTime')"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>

            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-md">{{ $t('client') }}</div>
            <div class="col-md">{{ $t('info') }}</div>
            <div class="col-md text-center">{{ $t('billing') }}</div>
            <div class="col-md">{{ $t('time') }}</div>
            <div class="col-md text-center">{{ $t('status') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-md">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>
              <span v-if="item.client">{{ item.client.companyName }} ({{ item.client.domain }})</span>
              <span v-else>{{ $t('unknown') }}</span>
            </div>
            <div class="col-md">
              <p><b>{{ $t(`${item.type}InvoicePlanOrderType`) }}</b></p>

              <template v-if="item.type === 'new'">
                <p v-if="item.plan">
                  <b>{{ $t('planName') }}: </b>
                  <span>{{ item.plan.name }}</span>
                </p>
                <p>
                  <b>{{
                      $t('invoicePlanPrice', [new Intl.NumberFormat().format(item.invoiceQuantity)])
                    }}:&nbsp;</b>
                  <span>{{ item.invoicePrice | numFormat }}</span>
                </p>
                <p>
                  <b>{{ $t('setupFee') }}:&nbsp;</b>
                  <span v-if="item.setupFee">{{ item.setupFee | numFormat }}</span>
                  <span v-else class="text-success">{{ $t("free") }}</span>
                </p>
                <template v-if="item.isEsign">
                  <p>
                    <b>{{ $t('esignPriceBuy') }}:&nbsp;</b>
                    <span v-if="item.esignYearCount > 1">{{ item.esignYearCount }} x </span>
                    {{ item.esignPrice | numFormat }}
                  </p>
                  <p>
                    <b>{{ $t('esignExpireTimeBuy') }}:&nbsp;</b>
                    <span>{{ item.esignExpireTime | moment('DD/MM/YYYY') }}</span>
                  </p>
                </template>
              </template>
              <template v-if="item.type === 'extend'">
                <p v-if="item.plan">
                  <b>{{ $t('planName') }}: </b>
                  <span>{{ item.plan.name }}</span>
                </p>
                <p>
                  <b>{{
                      $t('invoicePlanPrice', [new Intl.NumberFormat().format(item.invoiceQuantity)])
                    }}:&nbsp;</b>
                  <span>{{ item.invoicePrice | numFormat }}</span>
                </p>
              </template>
              <template v-if="item.type === 'esign'">
                <p>
                  <b>{{ $t('esignPriceBuy') }}:&nbsp;</b>
                  <span v-if="item.esignYearCount > 1">{{ item.esignYearCount }} x </span>
                  {{ item.esignPrice | numFormat }}
                </p>
                <p>
                  <b>{{ $t('esignExpireTimeBuy') }}:&nbsp;</b>
                  <span>{{ item.esignExpireTime | moment('DD/MM/YYYY') }}</span>
                </p>
              </template>

              <p v-if="item.note">
                <b>{{ $t('note') }}:&nbsp;</b>
                <span>{{ item.note }}</span>
              </p>
            </div>
            <div class="col-md text-center">
              <b class="text-danger">{{ item.total | numFormat }}</b>
            </div>
            <div class="col-md">
              <p>
                <b>{{ $t('createTime') }}:&nbsp;</b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.confirmTime">
                <b>{{ $t('confirmTime') }}:&nbsp;</b>
                <span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.cancelTime">
                <b>{{ $t('cancelTime') }}:&nbsp;</b>
                <span>{{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
            </div>
            <div class="col-md text-center">
              <p>
                <label v-if="!item.cancelTime && !item.confirmTime"
                       class="badge badge-warning">{{ $t('waiting') }}</label>
                <label v-else-if="item.confirmTime"
                       class="badge badge-success">{{ $t('confirmed') }}</label>
                <label v-else class="badge badge-dark">{{ $t('canceled') }}</label>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from "@/mixins/List";
import ClientSelect from "../../components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import _ from 'lodash';

export default {
  components: {
    ClientSelect, TimeRangePicker
  },
  mixins: [List],
  data: function () {
    return {
      service: '/invoice-plan-order',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        client: null,
        type: null,
        status: null
      },
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load: _.debounce(function () {
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    }, 200, {leading: true, trailing: false}),
  },
  i18n: {
    messages: {
      en: {
        title: 'Electronic invoice order',
        time: 'Time',
        billing: "Billing",
        newInvoicePlanOrderType: "Register to issue electronic invoices",
        extendInvoicePlanOrderType: "Buy additional electronic invoices",
        esignInvoicePlanOrderType: "Buy digital signature",
        planName: "Plan name",
        invoicePlanPrice: "Invoice Plan Price / {0} invoices",
        setupFee: "Setup fees",
        esignExpireTimeBuy: "Renew digital signature to",
        esignPriceBuy: "Digital signature price / year",
        waiting: "Waiting",
        confirmed: "Confirmed",
        canceled: "Canceled",
        confirmTime: "Confirm time",
        cancelTime: "Cancel time",
        free: "Free",
        allTypes: 'All types'
      },
      vi: {
        title: 'Đơn hàng hoá đơn điện tử',
        time: 'Thời gian',
        billing: "Thanh toán",
        newInvoicePlanOrderType: "Đăng ký phát hành hoá đơn điện tử",
        extendInvoicePlanOrderType: "Mua thêm hoá đơn điện tử",
        esignInvoicePlanOrderType: "Mua chữ ký số",
        planName: "Tên gói",
        invoicePlanPrice: "Giá gói hoá đơn / {0} hoá đơn",
        setupFee: "Phí cài đặt",
        esignExpireTimeBuy: "Gia hạn chữ ký số đến",
        esignPriceBuy: "Giá chữ ký số / năm",
        waiting: "Đợi xác nhận",
        confirmed: "Đã xác nhận",
        canceled: "Đã huỷ",
        confirmTime: "Xác nhận lúc",
        cancelTime: "Huỷ lúc",
        free: "Miễn phí",
        allTypes: 'Tất cả các loại'
      }
    }
  }
}
</script>